import { render, staticRenderFns } from "./LawLedesDetailList.vue?vue&type=template&id=9e880a46&"
import script from "./LawLedesDetailList.vue?vue&type=script&lang=js&"
export * from "./LawLedesDetailList.vue?vue&type=script&lang=js&"
import style0 from "./LawLedesDetailList.vue?vue&type=style&index=0&id=9e880a46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports